import "./App.css";

function App() {
  return (
    <div className="App">
      <div className="container">
        <div className="header">
          <div className="header-content">
            <img src="/terry-character.png" alt="Terry - Professional Tire Technician" className="terry-character" />
            <div className="title-wrapper">
              <h1 className="title">
                Terry's
                <span className="roadside">ROADSIDE</span>
                <span className="tire-service">TIRE SERVICE</span>
              </h1>
              <div className="badge-24-7">AVAILABLE 24/7</div>
            </div>
          </div>
        </div>

        <div className="content">
          <div className="guarantee">
            <h2>
              LOWEST PRICE
              <br />
              ON SERVICE OR IT'S <span className="free">FREE!</span>
            </h2>
          </div>

          <div className="services">
            <ul>
              <li>FLEET MANAGEMENT</li>
              <li>NEW AND USED TIRE REPAIR AND REPLACEMENT</li>
              <li>SPECIALIZES IN FARM AND AG EQUIPMENT</li>
              <li>EMERGENCY ROADSIDE SERVICE AVAILABLE 24/7</li>
            </ul>
          </div>

          <div className="contact">
            <div className="contact-item">
              <span className="label">📞 PHONE:</span>
              <a href="tel:209-484-4154">209-484-4154</a>
            </div>
            <div className="contact-item">
              <span className="label">📧 EMAIL:</span>
              <a href="mailto:terryfleming150@gmail.com">
                terryfleming150@gmail.com
              </a>
            </div>
          </div>
        </div>

        <footer className="footer">
          <div className="lic-insured">LIC & INSURED</div>
          <p>Professional Tire Service • Family Owned & Operated</p>
        </footer>
      </div>
    </div>
  );
}

export default App;
